import { FC } from 'react';
import moment from 'moment';
import { Perform } from './perform';

interface PerformDateProps {
    name: string;
    value?: Date | undefined;
}

function getFormatDate(date: Date) {
    return moment(date).format('MM/DD/YY');
}

export const PerformDate: FC<PerformDateProps> = ({ value, name }: PerformDateProps) => {
    const text = value ? getFormatDate(value) : '';
    return <Perform name={name} text={text} />;
};
